import { helpers } from '@vuelidate/validators'
import { useOptionsStore } from '@/stores/options'
import { isOneOfOptions, oneOfOptionsOrEmpty } from '@/helpers/customValidators'

const getSignatoryResidencyOptions = () => useOptionsStore().countrySignatoryResidencyOptions

export const isSignatoryResidencyCountry = isOneOfOptions(getSignatoryResidencyOptions)

export const signatoryResidencyCountry = helpers.withMessage(
    '§eq_operator.auth_person_country_not_allowed',
    oneOfOptionsOrEmpty(getSignatoryResidencyOptions)
)
